export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return "—";
  const units = ["B", "KiB", "MiB", "GiB", "TiB"];
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) { value /= 1024; unit += 1; }
  return `${value >= 10 || unit === 0 ? value.toFixed(0) : value.toFixed(1)} ${units[unit]}`;
}

export function formatDate(nanoseconds: string): string {
  let milliseconds: number;
  try { milliseconds = Number(BigInt(nanoseconds) / 1_000_000n); } catch { return "—"; }
  const date = new Date(milliseconds);
  if (Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat("zh-CN", {
    year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
  }).format(date);
}

export function outcomeLabel(value: string): string {
  const labels: Record<string, string> = { success: "成功", failure: "失败", failed: "失败", aborted: "中止", unknown: "未知" };
  return labels[value.toLowerCase()] ?? value;
}
